import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { CheckDoubleBookingService } from '../check-double-booking.service';
import { CheckDoubleBooking } from '../check-double-booking';
import { ReservationService } from '@app/_components/reservation/reservation.service';

@Component({
    selector: 'app-check-double-booking-list',
    templateUrl: './check-double-booking-list.component.html',
    styleUrls: ['./check-double-booking-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class CheckDoubleBookingListComponent implements OnInit {
	reservations: any[]=[];
	reservationStatuses: any[];
	reservationStatus1: any;
	constructor(
		private checkDoubleBookingService: CheckDoubleBookingService,
		private alertService: AlertService,
		private messageService: MessageService,
		private reservationService: ReservationService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = checkDoubleBookingService.statuses;
		this.reservationStatuses = this.reservationService.reservationStatuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	checkDoubleBookings: any;
	checkDoubleBooking: CheckDoubleBooking;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'shortTermRentalId', header: 'Property', width: 'auto' },
		{ field: 'createDate', header: 'Create-Date', width: 'auto' },
		{ field: 'reservationId', header: 'ReservationId', width: 'auto' },
		{ field: 'reservationStatus', header: 'Status', width: 'auto' },
		{ field: 'lastName', header: 'Guest Name', width: 'auto' },
		{ field: 'checkInDate', header: 'Check-In-Date', width: 'auto' },
		{ field: 'checkOutDate', header: 'Check-Out-Date', width: 'auto' },
		{ field: 'doubleBooking', header: 'DoubleBooking?', width: 'auto' },
	];

	ngOnInit(): void {
		this.fetchReservations();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	// loadLazy(event: LazyLoadEvent) {
	// 	try {
	// 		this.loading = true;
	// 		this.lazyLoadEvent = event;

	// 		console.log(
	// 			' event.first:' + event.first
	// 			+ '  |  event.rows:' + event.rows
	// 			+ '  |  event.sortField:' + event.sortField
	// 			+ '  |  event.sortOrder:' + event.sortOrder
	// 			+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
	// 			+ '  |  event.globalFilter:' + event.globalFilter
	// 			+ '  |  event.filters:' + JSON.stringify(event.filters)
	// 		);

	// 		/*
	// 		*
	// 		* Default Sort
	// 		*/
	// 		// https://stackoverflow.com/questions/679915/how-do-i-checkDoubleBooking-for-an-empty-javascript-object
	// 		// if we are NOT filtering and we are NOT sorting, apply a default sort
	// 		if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
	// 			event.multiSortMeta = [];
	// 			event.multiSortMeta.push({ field: 'createDate', order: -1 });
	// 		}

	// 		const pageNumber = Math.round(event.first / event.rows);
	// 		this.checkDoubleBookingService.findByFilter(
	// 			pageNumber, event.rows,
	// 			event.sortField,
	// 			event.sortOrder,
	// 			event.multiSortMeta,
	// 			event.globalFilter,
	// 			event.filters).pipe(first()).subscribe(

	// 				(res: any) => {
	// 					this.datasource = res.data.reviews;
	// 					this.recordTotal = res.page.recordTotal;
	// 					this.checkDoubleBookings = res.data.checkDoubleBookings;
	// 					console.log(JSON.stringify(res.page));
	// 				},
	// 				(err: any) => {
	// 					console.log('reviews list error!: ' + JSON.stringify(err));
	// 					this.alertService.error(err);
	// 				},
	// 				() => { this.loading = false; }
	// 			);

	// 		if (this.datasource) {
	// 			this.checkDoubleBookings = this.datasource.slice(event.first, (event.first + event.rows));
	// 		}
	// 	} catch (error) {
	// 		console.log('loadLazy(' + event + ')' + error);
	// 	}
	// }

	fetchReservations() {
		try {
			this.checkDoubleBookingService.findAllYieldMaxApiUrl()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.reservations = res.data.reservations;
						return this.reservations;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.loading = false
					});
		} catch (error) {
			this.loading = false
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getStatus() {
		return
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(checkDoubleBooking: CheckDoubleBooking) {
		try {
			this.formLoading = true;
			this.checkDoubleBookingService.update(checkDoubleBooking)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.checkDoubleBookings.map((checkDoubleBooking, i) => {
							if (checkDoubleBooking.checkDoubleBookingId === res.data.checkDoubleBooking.checkDoubleBookingId) {
								this.checkDoubleBookings[i] = res.data.checkDoubleBooking;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.checkDoubleBookings ? this.first === (this.checkDoubleBookings.length - this.rows) : true; }
	isFirstPage(): boolean { return this.checkDoubleBookings ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(checkDoubleBooking: any) {
		if (checkDoubleBooking?.reservationStatus) {
			const status = this.reservationStatuses.find((e: any) => e.value == checkDoubleBooking.reservationStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	getResStatusName(resStatus)
	{
		let status = this.reservationStatuses.find(function (item) { return item.value === resStatus });
		if(status){
			this.reservationStatus1 = status.name;
			return status.name
		}else{
			return	resStatus
		}
	}

	getResStatusColor(resStatus)
	{
		let status = this.reservationStatuses.find(function (item) { return item.value === resStatus });
		if(status){
			return status.color
		}else{
			return	''
		}
	}

	getSyncColor(isSync){
		if(isSync){
			return 'rgba(243,0,0,0.34)'
		}else{
			return  '#00800085';
		}
	}


	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	removeNull(slConfNumber: any){
		return slConfNumber != 'null' ? slConfNumber : "";;
	}
}
